module.exports = __webpack_public_path__ + "files/e3d26b268e50407defd43091d45912f4.png";